import { createFileRoute } from "@tanstack/react-router";
import HowItWorks from "@/pages/HowItWorks";

export const Route = createFileRoute("/hoe-werkt-het")({
  head: () => ({
    meta: [
      { title: "Hoe werkt De Hussel App? Slimme baanindeling uitgelegd" },
      { name: "description", content: "Ontdek hoe De Hussel App automatische hussel- en toss-indelingen maakt op basis van speelsterkte, gespeelde rondes en tegenstanders — in 4 stappen." },
      { property: "og:title", content: "Hoe werkt De Hussel App? Slimme baanindeling uitgelegd" },
      { property: "og:description", content: "Ontdek hoe De Hussel App automatische hussel- en toss-indelingen maakt op basis van speelsterkte, gespeelde rondes en tegenstanders — in 4 stappen." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/hoe-werkt-het" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/hoe-werkt-het" }],
  }),
  component: HowItWorks,
});
